/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
export interface RecorderEmitContext {
	data: Record<string, unknown>
	onSessionChanged: () => void
	startTime: number
	type: 'splunk' | 'rrweb'
}

export interface RecorderConfig {
	onEmit: (context: RecorderEmitContext) => void
}

export abstract class Recorder {
	protected onEmit: RecorderConfig['onEmit']

	protected constructor(config: RecorderConfig) {
		this.onEmit = config.onEmit
	}

	abstract pause(): void

	abstract resume(): void

	abstract start(): void

	abstract stop(): void
}
